import tempMeeApi from '../../../apis/tempMee';

export const getPromotionPayouts = async (promotionId) => {
  const response = await tempMeeApi.get(
    `/payment/admin/promotion-campaigns/${promotionId}/payouts`,
  );

  return response.data;
};
